import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Login,
  Home,
  CreatePool,
  ViewPool,
  Results,
  PoolDetail,
  AdminUsers,
  AdminLeagues,
  ManageCodes,
  Stats,
  Over05HTStats,
  Over05HTOddsStats,
} from "../UI/views";

const RequireAuth = ({ children }) => {
  const session = useSelector((state) => state.session);

  if (!session?.token) return <Navigate to='/login' replace />;
  return children;
};

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route
          path='/home'
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route path='/login' element={<Login />} />
        <Route
          path='/create-pool'
          element={
            <RequireAuth>
              <CreatePool />
            </RequireAuth>
          }
        />
        <Route
          path='/view-pool'
          element={
            <RequireAuth>
              <ViewPool />
            </RequireAuth>
          }
        />
        <Route
          path='/results'
          element={
            <RequireAuth>
              <Results />
            </RequireAuth>
          }
        />
        <Route
          path='/pool-detail'
          element={
            <RequireAuth>
              <PoolDetail />
            </RequireAuth>
          }
        />
        <Route
          path='/admin-users'
          element={
            <RequireAuth>
              <AdminUsers />
            </RequireAuth>
          }
        />
        <Route
          path='/admin-leagues'
          element={
            <RequireAuth>
              <AdminLeagues />
            </RequireAuth>
          }
        />
        <Route
          path='/manage-codes'
          element={
            <RequireAuth>
              <ManageCodes />
            </RequireAuth>
          }
        />
        <Route
          path='/stats'
          element={
            <RequireAuth>
              <Stats />
            </RequireAuth>
          }
        />
        <Route
          path='/stats/over05HT'
          element={
            <RequireAuth>
              <Over05HTStats />
            </RequireAuth>
          }
        />
        <Route
          path='/stats/over05HTOdds'
          element={
            <RequireAuth>
              <Over05HTOddsStats />
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
